import React, {Component} from 'react'
import PropTypes from 'prop-types'

import styles from './NestedField.less'

const {
    'label': label_class,
    'content-block': content_class,
} = styles

export default class NestedField extends Component {
    render() {
        const {label, children, contentClassName} = this.props

        const content_classes = [content_class]
        if (contentClassName) {
            content_classes.push(contentClassName)
        }

        if (label) {
            return (
                <div>
                    <div className={label_class}>{label}</div>
                    <div className={content_classes.join(' ')}>{children}</div>
                </div>
            )
        } else {
            return (
                <div className={content_classes.join(' ')}>{children}</div>
            )
        }
    }
}

NestedField.propTypes = {
    label: PropTypes.any,
    contentClassName: PropTypes.any
}